document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-scroll-to-product]');
    if (!trigger) return;

    const offset = parseInt(trigger.getAttribute('data-scroll-offset'), 10) || 0;
    const target = document.getElementById('product-section');

    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: top,
        behavior: 'smooth'
    });
});